<template>
  <div>
    <!-- <Header /> -->

    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div class="flex">
      <SideBar />

      <!-- {{  studentList }} -->

      <div
        class="w-[90%] px-10 py-5 mx-auto lg:w-full lg:mr-10 mt-10 pb-20 rounded-3xl overflow-x-auto overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <!-- <pre>{{ studentAllList }}</pre> -->
        <div
          v-if="this.userSelectList != 0"
          class="flex flex-wrap md:items-center md:justify-end gap-3 md:gap-5 py-5"
        >
          <button
            class="bg-blues text-white px-5 py-1.5 rounded-2xl font-semibold text-xs hover:bg-blue-700 transition-all duration-200"
            @click="this.popupMailAll = true"
          >
            Send Mail
          </button>
          <button
            class="bg-blues text-white px-5 py-1.5 rounded-2xl font-semibold text-xs hover:bg-blue-700 transition-all duration-200"
            @click="this.popUpAll = true"
          >
            Push Notifications
          </button>
          <button
            class="bg-blues text-white px-5 py-1.5 rounded-2xl font-semibold text-xs flex items-center justify-center hover:bg-blue-700 transition-all duration-200"
            @click="userdeownload"
            :disabled="isDownload"
          >
            <span v-if="!isDownload">Download</span>
            <span v-else class="flex items-center gap-2">
              <svg
                class="animate-spin h-4 w-4 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  class="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="4"
                ></circle>
                <path
                  class="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 00-8 8z"
                ></path>
              </svg>
              Download...
            </span>
          </button>
        </div>

        <div class="flex flex-col gap-2 md:flex-row justify-between w-full">
          <div class="">
            <h1 class="text-xl font-semibold text-gray-800">
              Student List
              <span class="ml-2 text-sm font-normal text-gray-500">
                ({{ studentcount || 0 }})
              </span>

              <span
                v-if="userSelectList.length > 0"
                class="ml-3 pl-3 border-l border-gray-200 text-sm font-medium text-indigo-600"
              >
                Selected: {{ userSelectList.length }}
              </span>
            </h1>
            <p class="text-sm text-gray-500 mt-0.5">
              Only active student records are displayed here
            </p>
          </div>

          <div class="">
            <div class="relative w-full md:max-w-80">
              <div
                class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4 text-gray-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
              <input
                type="text"
                v-model="searching"
                @input="getstudentdetails(1)"
                placeholder="Search..."
                class="w-full rounded-xl border border-gray-200 bg-white pl-10 pr-10 py-2 text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
              />
              <button
                v-if="searching"
                @click="clearSearch"
                class="absolute inset-y-0 right-0 pr-3 flex items-center"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4 text-gray-400 hover:text-gray-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div class="mt-5">
          <div
            class="w-full bg-[#edf8ff] flex justify-center gap-5 items-center px-2 py-2 mb-4 lg:px-8 rounded-md"
            v-if="response_message"
          >
            <h2 class="text-blues text-center">
              {{ response_message }}
            </h2>

            <router-link
              :to="{ name: 'DownloadHistory' }"
              class="text-blue-600 text-xs underline font-bold"
            >
              Download History
            </router-link>
          </div>
        </div>
        <div
          class="w-full overflow-x-auto rounded-lg border border-gray-200 shadow-sm"
        >
          <table class="min-w-full divide-y divide-gray-200 text-xs">
            <thead class="bg-gray-50">
              <tr class="divide-x divide-gray-200 whitespace-nowrap">
                <th class="py-2 px-3 font-semibold text-blues text-left w-12">
                  <input
                    type="checkbox"
                    v-model="selectAll"
                    @change="toggleSelectAll"
                    class="w-4 h-4 rounded text-blue-600 border-gray-400"
                  />
                </th>
                <th class="py-2 px-3 font-semibold text-blues text-center w-16">
                  S NO
                </th>
                <th
                  class="py-2 px-3 font-semibold text-blues text-left min-w-[180px]"
                >
                  <div
                    class="flex justify-start items-center gap-1 cursor-pointer select-none"
                    @click="toggleSort('display_name')"
                  >
                    Name
                    <svg
                      class="w-3.5 h-3.5 transition-transform duration-200"
                      :class="arrowClass('display_name')"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <polygon points="10 5 3 15 17 15" />
                    </svg>
                  </div>
                </th>
                <th
                  class="py-2 px-3 font-semibold text-blues text-left min-w-[140px]"
                >
                  Batch- Program
                </th>
                <th
                  class="py-2 px-3 font-semibold text-blues text-left min-w-[150px]"
                >
                  <div
                    class="flex justify-start items-center gap-1 cursor-pointer select-none"
                    @click="toggleSort('profile_created_at')"
                  >
                    Account Created
                    <svg
                      class="w-3.5 h-3.5 transition-transform duration-200"
                      :class="arrowClass('profile_created_at')"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <polygon points="10 5 3 15 17 15" />
                    </svg>
                  </div>
                </th>
                <th
                  class="py-2 px-3 font-semibold text-blues text-left min-w-[150px]"
                >
                  <div
                    class="flex justify-start items-center gap-1 cursor-pointer select-none"
                    @click="toggleSort('profile_last_in')"
                  >
                    Last Login
                    <svg
                      class="w-3.5 h-3.5 transition-transform duration-200"
                      :class="arrowClass('profile_last_in')"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <polygon points="10 5 3 15 17 15" />
                    </svg>
                  </div>
                </th>
                <th class="py-2 px-3 font-semibold text-blues text-center w-24">
                  <div
                    class="flex justify-center items-center gap-1 cursor-pointer select-none"
                    @click="toggleSort('completed_lessons_count')"
                  >
                    Progress
                    <svg
                      class="w-3.5 h-3.5 transition-transform duration-200"
                      :class="arrowClass('completed_lessons_count')"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <polygon points="10 5 3 15 17 15" />
                    </svg>
                  </div>
                </th>
                <th class="py-2 px-3 font-semibold text-blues text-center w-24">
                  <div
                    class="flex justify-center items-center gap-1 cursor-pointer select-none"
                    @click="toggleSort('completion_percentage')"
                  >
                    Percentage
                    <svg
                      class="w-3.5 h-3.5 transition-transform duration-200"
                      :class="arrowClass('completion_percentage')"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <polygon points="10 5 3 15 17 15" />
                    </svg>
                  </div>
                </th>

                <th class="py-2 px-3 font-semibold text-blues text-left">
                  <div
                    class="flex justify-center items-center gap-1 cursor-pointer select-none"
                    @click="toggleSort('assignment_current_mark_order')"
                  >
                    Assignment

                    <svg
                      class="w-3.5 h-3.5 transition-transform duration-200"
                      :class="arrowClass('assignment_current_mark_order')"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <polygon points="10 5 3 15 17 15" />
                    </svg>
                  </div>
                </th>
                <th class="py-2 px-3 font-semibold text-blues text-left">
                  <div
                    class="flex justify-center items-center gap-1 cursor-pointer select-none"
                    @click="toggleSort('lesson_current_mark_order')"
                  >
                    Assessment

                    <svg
                      class="w-3.5 h-3.5 transition-transform duration-200"
                      :class="arrowClass('lesson_current_mark_order')"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <polygon points="10 5 3 15 17 15" />
                    </svg>
                  </div>
                </th>
                <th class="py-2 px-3 font-semibold text-blues text-left w-28">
                  <div
                    class="flex justify-center items-center gap-1 cursor-pointer select-none"
                    @click="toggleSort('overall_mark_order')"
                  >
                    Overall Mark

                    <svg
                      class="w-3.5 h-3.5 transition-transform duration-200"
                      :class="arrowClass('overall_mark_order')"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <polygon points="10 5 3 15 17 15" />
                    </svg>
                  </div>
                </th>
                <th class="py-2 px-3 font-semibold text-blues text-center w-20">
                  Mail To
                </th>
              </tr>
            </thead>

            <tbody v-if="loading" class="divide-y divide-gray-100 bg-white">
              <tr
                v-for="n in 5"
                :key="'loader-' + n"
                class="animate-pulse divide-x divide-gray-50 whitespace-nowrap"
              >
                <td class="py-3 px-3">
                  <div class="h-4 w-4 bg-gray-200 rounded mx-auto"></div>
                </td>
                <td class="py-3 px-3">
                  <div class="h-3 w-6 bg-gray-100 rounded mx-auto"></div>
                </td>
                <td class="py-3 px-3">
                  <div class="flex items-center gap-2">
                    <div
                      class="w-7 h-7 rounded-full bg-gray-200 flex-shrink-0"
                    ></div>
                    <div class="flex flex-col gap-1.5 w-full">
                      <div class="h-3 w-32 bg-gray-200 rounded"></div>
                      <div class="h-2.5 w-40 bg-gray-100 rounded"></div>
                    </div>
                  </div>
                </td>
                <td class="py-3 px-3">
                  <div class="h-3 w-28 bg-gray-100 rounded"></div>
                </td>
                <td class="py-3 px-3">
                  <div class="h-3 w-36 bg-gray-100 rounded"></div>
                </td>
                <td class="py-3 px-3">
                  <div class="h-3 w-36 bg-gray-100 rounded"></div>
                </td>
                <td class="py-3 px-3">
                  <div class="h-3 w-10 bg-gray-100 rounded mx-auto"></div>
                </td>
                <td class="py-3 px-3">
                  <div class="h-3 w-8 bg-gray-100 rounded mx-auto"></div>
                </td>
                <td class="py-3 px-3">
                  <div class="h-3 w-16 bg-gray-100 rounded"></div>
                </td>
                <td class="py-3 px-3">
                  <div class="h-3 w-16 bg-gray-100 rounded"></div>
                </td>
                <td class="py-3 px-3">
                  <div class="h-3 w-16 bg-gray-100 rounded"></div>
                </td>
                <td class="py-3 px-3">
                  <div class="h-6 w-6 bg-gray-100 rounded-lg mx-auto"></div>
                </td>
              </tr>
            </tbody>

            <tbody
              v-else-if="studentList && studentList.length"
              class="divide-y divide-gray-100 bg-white"
            >
              <tr
                v-for="(el, index) in studentList"
                :key="el.id"
                class="hover:bg-gray-50 transition-colors divide-x divide-gray-100 whitespace-nowrap"
              >
                <td class="py-2 px-3 text-left text-gray-500 font-medium">
                  <input
                    type="checkbox"
                    :value="el.id"
                    v-model="userSelectList"
                    class="w-4 h-4 rounded text-blue-600 border-gray-400"
                  />
                </td>

                <td class="py-2 px-3 text-center text-gray-500 font-medium">
                  {{ (currentPage - 1) * pageSize + index + 1 }}
                </td>

                <td class="py-2 px-3 text-left font-medium text-slate-700">
                  <div class="flex items-center gap-2">
                    <div
                      class="w-7 h-7 flex-shrink-0 uppercase rounded-full bg-indigo-50 flex items-center justify-center text-[10px] font-bold text-indigo-600"
                    >
                      {{ el?.display_name?.charAt(0) || "?" }}
                    </div>
                    <div class="flex flex-col min-w-0">
                      <span
                        class="text-xs font-semibold uppercase text-slate-700"
                      >
                        {{ el?.display_name || "NA" }}
                      </span>
                      <div
                        class="text-[12px] text-gray-500 flex items-center gap-1 break-words"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="12px"
                          viewBox="0 -960 960 960"
                          width="12px"
                          fill="#9CA3AF"
                        >
                          <path
                            d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280L160-640v400h640v-400L480-440Zm0-80 320-200H160l320 200ZM160-640v-80 480-400Z"
                          />
                        </svg>
                        {{ el?.email || "NA" }}
                      </div>
                      <div class="text-gray-500 mt-1 text-[10px]">
                        <span class="text-slate-600">PRN: </span>
                        <span class="text-gray-500">{{
                          el?.profile_data?.prn_number || "NA"
                        }}</span>
                      </div>
                    </div>
                  </div>
                </td>

                <td class="py-2 px-3 text-left font-medium text-gray-600">
                  {{ el?.profile_data?.batch?.year || "NA" }}-{{
                    el?.profile_data?.program?.name || "NA"
                  }}
                </td>

                <td class="py-2 px-3 text-left font-medium text-gray-600">
                  {{
                    new Date(el.lms_joined_date).toLocaleDateString("en-IN", {
                      day: "numeric",
                      month: "long",
                      year: "numeric",
                    })
                  }}
                  -
                  {{ new Date(el.lms_joined_date).toLocaleTimeString("en-IN") }}
                </td>

                <td class="py-2 px-3 text-left font-medium text-gray-600">
                  {{
                    el.last_in
                      ? `${new Date(el.last_in).toLocaleDateString("en-IN", {
                          day: "numeric",
                          month: "long",
                          year: "numeric",
                        })} - ${new Date(el.last_in).toLocaleTimeString(
                          "en-IN",
                        )}`
                      : "NA"
                  }}
                </td>

                <td class="py-2 px-3 text-center font-medium text-gray-600">
                  {{ el.completed_lessons_count }}/{{ el.total_lessons_count }}
                </td>

                <td class="py-2 px-3 text-center font-medium text-gray-600">
                  {{ el.completion_percentage }}
                </td>

                <td class="py-2 px-3 text-center font-medium text-gray-600">
                  {{
                    el?.assignment_current_mark != null ||
                    el?.internal_mark?.assignment != null
                      ? `${el?.assignment_current_mark ?? "NA"}/${
                          el?.internal_mark?.assignment ?? "?"
                        }`
                      : "NA"
                  }}
                </td>
                <td class="py-2 px-3 text-center font-medium text-gray-600">
                  <span
                    v-if="
                      el?.lesson_current_mark != null ||
                      el?.internal_mark?.assessment != null
                    "
                  >
                    {{ el?.lesson_current_mark ?? "NA" }}/{{
                      el?.internal_mark?.assessment ?? "?"
                    }}
                  </span>
                  <span v-else>NA</span>
                </td>

                <td class="py-2 px-3 text-center font-medium text-gray-600">
                  <span
                    v-if="
                      el?.overall_mark != null ||
                      el?.internal_mark?.total != null
                    "
                  >
                    {{ el?.overall_mark ?? "NA" }}/{{
                      el?.internal_mark?.total ?? "?"
                    }}
                  </span>
                  <span v-else>NA</span>
                </td>

                <td class="py-2 px-3 text-left font-medium text-gray-600">
                  <div class="flex justify-center">
                    <div
                      @click="
                        popUp = true;
                        mailid = el;
                      "
                      class="flex items-center justify-center w-9 h-9 rounded-xl hover:bg-gradient-to-br from-blue-50 to-blue-100 text-gray-600 hover:shadow-sm cursor-pointer"
                      :title="el?.email || 'Send Email'"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="w-5 h-5"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path
                          d="M20 4H4a2 2 0 00-2 2v.01l10 6.25L22 6.01V6a2 2 0 00-2-2zm2 4.236l-9.445 5.903a1 1 0 01-1.11 0L2 8.236V18a2 2 0 002 2h16a2 2 0 002-2V8.236z"
                        />
                      </svg>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>

            <tbody v-else>
              <tr>
                <td
                  colspan="12"
                  class="text-center py-8 text-gray-600 font-medium"
                >
                  No Data Found
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- <Pagination
          v-if="totalPages > 1"
          :totalPages="totalPages"
          ref="paginationRef"
          @page-changed="getstudentdetails"
        /> -->

        <div
          v-if="studentcount >= 11"
          class="flex flex-col sm:flex-row justify-center gap-3 mt-4 relative"
        >
          <!-- PAGE SIZE -->
          <div
            class="md:absolute md:left-3 md:top-4 gap-2 text-sm text-gray-600 flex justify-center items-center md:flex-none md:justify-normal"
          >
            <span class="flex md:hidden">Rows per page:</span>
            <select
              v-model="pageSize"
              @change="onPageSizeChange"
              class="border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option :value="10">10</option>
              <option :value="20">20</option>
              <option :value="50">50</option>
              <option :value="100">100</option>
            </select>
          </div>

          <!-- PAGINATION -->
          <div class="flex justify-center">
            <Pagination
              :totalPages="totalPages"
              ref="paginationRef"
              @page-changed="getstudentdetails"
            />
          </div>
        </div>
      </div>

      <!-- <div class="">  
            <div class="flex w-full pt-10">
                <div class="flex rounded-2xp-4box-shadow: 0px 2px 30px 0px #01B0F926;"> 
                    <table clas="table-autop-4
                        <thead> p-4
                            <tr>p-4
                                <th class="p-4 text-center border-r">S NO</th>
                                <th class="p-4 text-center border-r">Name</th>
                                <th class="p-4 text-center border-r">Email</th>
                                <th class="p-4 text-center border-r">Last login</th>
                                <th class="p-4 text-center">Mail to </th>
                            </tr>
                        </thead>
                        <tbody> 
                            <tr>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div> -->

      <div
        v-if="popUp"
        class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50"
      >
        <div class="relative w-full h-full flex items-center justify-center">
          <div
            class="w-[90%] lg:w-[40%] lg:absolute lg:bottom-4 lg:right-4 bg-white rounded-2xl p-10 overflow-y-auto max-h-[600px]"
          >
            <div class="flex items-center justify-between">
              <h3 class="text-xl font-bold text-blues">New Message</h3>
              <img
                src="@/assets/newd/close.png"
                class="cursor-pointer"
                alt=""
                @click="this.popUp = false"
              />
            </div>

            <div class="w-full flex flex-col py-6 relative">
              <div class="w-full">
                <form
                  ref="mailref"
                  @submit.prevent="sendmail"
                  class="flex flex-col gap-4 text-xs md:text-sm lg:text-base h-full"
                >
                  <div class="flex">
                    <p
                      class="bg-blues text-white font-semibold text-sm px-4 py-1 rounded-xl"
                    >
                      {{ this.mailid.display_name }}
                    </p>
                  </div>

                  <div
                    class="flex flex-col gap-2 w-full text-xs md:text-sm lg:text-base"
                  >
                    <div class="w-full flex flex-col gap-2">
                      <input
                        id="subject"
                        placeholder="Subject"
                        type="text"
                        class="border-b rounded outline-none text-xs md:text-sm lg:text-base py-2 px-2"
                        required
                      />
                    </div>
                  </div>
                  <!-- <div class="flex flex-col w-full gap-2">
                  <label for="description" class="text-left">Description</label>
                  <textarea
                    id="description"
                    rows="3"
                    cols="10"
                    class="border border-gray-100 h-full rounded text-xs md:text-sm lg:text-base py-2 px-2"
                  />
                </div> -->
                  <div class="flex flex-col gap-2 w-full mt-2">
                    <!-- <label for="attachments" class="text-left text-gray-400">
                    Message
                  </label> -->
                    <textarea
                      textarea
                      rows="12"
                      cols="10"
                      id="content"
                      class="border border-gray-200 outline-none h-full w-full p-2 rounded"
                      placeholder="Your message"
                    ></textarea>
                  </div>

                  <div class="flex justify-start mt-4">
                    <button
                      type="submit"
                      class="bg-blues px-8 py-2 text-sm text-white rounded-xl"
                    >
                      Send
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="this.popUpAll"
        class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50"
      >
        <div class="relative w-full h-full flex items-center justify-center">
          <div
            class="w-[90%] lg:w-[40%] lg:absolute lg:bottom-4 lg:right-4 bg-white rounded-2xl p-10 overflow-y-auto max-h-[600px]"
          >
            <div class="flex items-center justify-between">
              <h3 class="text-xl font-bold text-blues">Send Notifications</h3>
              <img
                src="@/assets/newd/close.png"
                class="cursor-pointer"
                alt=""
                @click="this.popUpAll = false"
              />
            </div>

            <div class="w-full flex flex-col py-6 relative">
              <div class="w-full">
                <form
                  ref="mailrefbulk"
                  @submit.prevent="sendmailNotifications"
                  class="flex flex-col gap-4 text-xs md:text-sm lg:text-base h-full"
                >
                  <div
                    class="flex flex-col gap-2 w-full text-xs md:text-sm lg:text-base"
                  >
                    <div class="w-full flex flex-col gap-2">
                      <input
                        id="subject"
                        placeholder="Subject"
                        type="text"
                        class="border rounded outline-none text-xs md:text-sm lg:text-base py-2 px-2"
                        required
                      />
                    </div>
                  </div>
                  <!-- <div class="flex flex-col w-full gap-2">
                  <label for="description" class="text-left">Description</label>
                  <textarea
                    id="description"
                    rows="3"
                    cols="10"
                    class="border border-gray-100 h-full rounded text-xs md:text-sm lg:text-base py-2 px-2"
                  />
                </div> -->
                  <div class="flex flex-col gap-2 w-full mt-2">
                    <!-- <label for="attachments" class="text-left text-gray-400">
                    Message
                  </label> -->
                    <textarea
                      textarea
                      rows="12"
                      cols="10"
                      id="content"
                      class="border border-gray-200 outline-none h-full w-full p-2 rounded"
                      placeholder="Your message"
                    ></textarea>
                  </div>

                  <div class="flex justify-start mt-4">
                    <button
                      type="submit"
                      class="bg-blues px-8 py-2 text-sm text-white rounded-xl"
                    >
                      Send
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="this.popupMailAll"
        class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50"
      >
        <div class="relative w-full h-full flex items-center justify-center">
          <div
            class="w-[90%] lg:w-[40%] lg:absolute lg:bottom-4 lg:right-4 bg-white rounded-2xl p-10 overflow-y-auto max-h-[600px]"
          >
            <div class="flex items-center justify-between">
              <h3 class="text-xl font-bold text-blues">Send Mails</h3>
              <img
                src="@/assets/newd/close.png"
                class="cursor-pointer"
                alt=""
                @click="this.popupMailAll = false"
              />
            </div>

            <div class="w-full flex flex-col py-6 relative">
              <div class="w-full">
                <form
                  ref="mailrefbulkmail"
                  @submit.prevent="sendmailMails"
                  class="flex flex-col gap-4 text-xs md:text-sm lg:text-base h-full"
                >
                  <div
                    class="flex flex-col gap-2 w-full text-xs md:text-sm lg:text-base"
                  >
                    <div class="w-full flex flex-col gap-2">
                      <input
                        id="subject"
                        placeholder="Subject"
                        type="text"
                        class="border rounded outline-none text-xs md:text-sm lg:text-base py-2 px-2"
                        required
                      />
                    </div>
                  </div>
                  <!-- <div class="flex flex-col w-full gap-2">
                  <label for="description" class="text-left">Description</label>
                  <textarea
                    id="description"
                    rows="3"
                    cols="10"
                    class="border border-gray-100 h-full rounded text-xs md:text-sm lg:text-base py-2 px-2"
                  />
                </div> -->
                  <div class="flex flex-col gap-2 w-full mt-2">
                    <!-- <label for="attachments" class="text-left text-gray-400">
                    Message
                  </label> -->
                    <textarea
                      textarea
                      rows="12"
                      cols="10"
                      id="content"
                      class="border border-gray-200 outline-none h-full w-full p-2 rounded"
                      placeholder="Your message"
                    ></textarea>
                  </div>

                  <div
                    class="flex flex-col gap-2 w-full text-xs md:text-sm lg:text-base"
                  >
                    <div class="w-full flex flex-col gap-2">
                      <input
                        id="files"
                        type="file"
                        class="border rounded outline-none text-xs md:text-sm lg:text-base py-2 px-2"
                        required
                      />
                    </div>
                  </div>

                  <div class="flex justify-start mt-4">
                    <button
                      type="submit"
                      class="bg-blues px-8 py-2 text-sm text-white rounded-xl"
                    >
                      Send
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Instructor/Header.vue";
import SideBar from "@/components/Instructor/SideBar.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import Pagination from "@/components/Pagination.vue";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  components: {
    Header,
    SideBar,
    FlashMessage,
    Pagination,
  },
  data() {
    return {
      userSelectList: [],
      popUpAll: false,
      popupMailAll: false,
      popUp: false,
      minimize: true,
      maximize: false,
      studentList: [],
      mailid: null,
      messages: {
        text: "",
        type: "null",
      },
      loading: true,
      searching: "",
      isDownload: false,
      currentPage: 1,
      totalPages: 1,
      pageArray: [],
      selectAll: false,
      studentAllList: [],
      response_message: "",
      selected_sort_filter: "",
      pageSize: 10,
      sortField: "",
      sortDirection: "asc",
      studentcount: "",
    };
  },
  created() {
    this.loading = true;
    this.getAllstudentdetails();
    this.getstudentdetails(1);
  },

  props: ["course_id"],

  computed: {
    ...mapGetters(["userInfo"]),
  },
  watch: {
    userSelectList() {
      this.selectAll =
        this.userSelectList.length === this.studentAllList.length;
    },
  },

  methods: {
    clearSearch() {
      this.searching = "";
      this.getstudentdetails(1);
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.userSelectList = this.studentAllList.map((x) => x.id);
      } else {
        this.userSelectList = [];
      }
    },
    // sort(order) {
    //   this.selected_sort_filter = order;

    //   this.getstudentdetails(1);
    // },
    toggleSort(field) {
      if (this.sortField === field) {
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      } else {
        this.sortField = field;
        this.sortDirection = "asc";
      }

      this.selected_sort_filter =
        this.sortDirection === "asc" ? field : `-${field}`;

      this.getstudentdetails(1);
    },

    arrowClass(field) {
      return {
        "rotate-180 text-blue-600":
          this.sortField === field && this.sortDirection === "desc",
        "text-blue-600": this.sortField === field,
        "text-slate-400": this.sortField !== field,
      };
    },
    onPageSizeChange() {
      this.currentPage = 1;
      if (this.$refs.paginationRef) {
        this.$refs.paginationRef.currentPage = 1;
      }
      this.getstudentdetails(1);
    },
    async sendmailNotifications() {
      await axios
        .post(
          `${process.env.VUE_APP_API}/user/notifications/?Key=${this.userInfo.token_key}`,
          {
            topic: document.getElementById("subject").value,
            message: document.getElementById("content").value,
            user_id: this.userSelectList,
          },
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };

            this.$refs.mailrefbulk.reset();
            this.popUpAll = false;
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.userSelectList = [];
            }, 1500);
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 1500);
          }
        });
    },

    async sendmailMails(el) {
      await axios
        .post(
          `${process.env.VUE_APP_API}/email_sent_selected_student/?Key=${this.userInfo.token_key}`,
          {
            topic: document.getElementById("subject").value,
            message: document.getElementById("content").value,
            user_id: JSON.stringify(this.userSelectList),
            attachments: el.target.elements.files.files[0],
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };

            this.$refs.mailrefbulkmail.reset();
            this.popupMailAll = false;
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.userSelectList = [];
            }, 1500);
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 1500);
          }
        });
    },

    async getAllstudentdetails() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/all_list/${this.course_id}/?Key=${this.userInfo.token_key}&search=${this.searching}&demo_user=false`,
        )
        .then((response) => {
          console.log(response);
          this.studentAllList = response.data.data || [];
          this.studentcount = response.data.data.length;
          // this.loading = false;
        });
    },
    async getstudentdetails(page = 1) {
      this.currentPage = page;

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/all_list/students/${this.course_id}/?Key=${this.userInfo.token_key}&page=${page}&search=${this.searching}&ordering=${this.selected_sort_filter}&page_size=${this.pageSize}&demo_user=false`,
        );

        console.log(response);

        this.totalPages = response.data.total_page || 1;
        this.studentList = response.data.data || [];
        this.currentPage = response.data.current_page || page;
        this.studentcount = response.data.total;
      } catch (error) {
        console.error("Error fetching student details:", error);
        this.studentList = [];
        this.totalPages = 1;
      } finally {
        this.loading = false;
      }
    },

    async sendmail(event) {
      const HeaderVal = {
        subject: event.target.elements.subject.value,
        time: "",
        content_1: event.target.elements.content.value,
        content_2: "",
        content_3: "",
      };

      await axios
        .post(
          `${process.env.VUE_APP_API}/user/notifications/?Key=${this.userInfo.token_key}`,
          {
            topic: event.target.elements.subject.value,
            message: event.target.elements.content.value,
            user_id: [this.mailid],
          },
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
        });

      this.$refs.mailref.reset();
      this.popUp = false;
      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
      }, 1500);
    },

    async sendmailallStudnt() {
      await axios
        .post(
          `${process.env.VUE_APP_API}/instructor_send_student/${this.course_id}/?Key=${this.userInfo.token_key}`,
        )
        .then((Response) => {
          if (Response.message == "successfully Email send") {
            this.messages = {
              text: "Mail Sent successfully",
              type: "success",
            };
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
        });
      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
      }, 1500);
    },
    async userdeownload() {
      if (this.isDownload) return;
      this.isDownload = true;

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API}/download_student_liist/?Key=${this.userInfo.token_key}`,
          {
            course_id: this.course_id,
            user_id: this.userSelectList,
          },
        );

        if (response.data.status === 200) {
          this.response_message =
            "Your file is ready to download go to download history page";

          setTimeout(() => {
            this.response_message = "";
            this.isDownload = false;
            this.userSelectList = [];
          }, 5000);
        } else {
          this.messages = {
            text: "Event Failed",
            type: "error",
          };
          console.log("not successful");
        }
      } catch (error) {
        console.error("Delete error:", error);
        this.messages = {
          text: "Something went wrong. Please try again.",
          type: "error",
        };
      } finally {
        setTimeout(async () => {
          this.messages = { text: "", type: "" };
        }, 2500);
      }
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
